import { b2bApiClient } from '@/shared/api/b2b-client'
import { captureApiError } from '@/shared/lib/captureApiError'

export default {
  async fetchRequisites({ commit, state }) {
    if (state.isLoading) {
      return
    }

    try {
      commit('SET_LOADING', true)

      const response = await b2bApiClient.getClient().get('/account/requisites')

      commit('SET_REQUISITES', response)

      return response
    } catch (error) {
      captureApiError('fetchRequisites', '/account/requisites', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchKybStatus({ commit, state }) {
    if (state.isKybStatusLoading) {
      return
    }

    try {
      commit('SET_KYB_STATUS_LOADING', true)

      const response = await b2bApiClient.getClient().get('/account/kyb/status')

      commit('SET_KYB_STATUS', response)

      return response
    } catch (error) {
      captureApiError('fetchKybStatus', '/account/kyb/status', error)
      throw error
    } finally {
      commit('SET_KYB_STATUS_LOADING', false)
    }
  },

  resetAccount({ commit }) {
    commit('RESET_ACCOUNT')
  },
}
